import "../styles/footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <p className="footer__text">
        Copyright © <span className="footer__text-number">2021</span> KeepTrack. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
